import React from 'react';
import { HashLoader } from 'react-spinners';
import '../Estilos/Loader.css';
export default function LoaderComponent(props) {
  return (
    <>
      {props.visible ? (
        <div className="LoaderView" style={{ height: props.altura }}>
          <HashLoader
            color={'#005288'}
            loading={true}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : null}
    </>
  );
}
